export default "__VITE_ASSET__B0N7yAlI__"